import { initGraphQLTada } from "gql.tada";

import type { GqlScalars } from "./schema/gql-scalars";
import type { introspection } from "./schema/graphql-env.d.ts";

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: GqlScalars;
}>();

export type { FragmentOf, ResultOf, VariablesOf } from "gql.tada";
export { readFragment } from "gql.tada";
